document.addEventListener('DOMContentLoaded', () => {
    const containers = document.querySelectorAll('.text-with-video-section .container-video');
    if (!containers.length) return;
  
    containers.forEach((container) => {
      const playButton = container.querySelector('.play-button');
      const mediaEl = container.querySelector('.video-element');
      if (!mediaEl) return; // No hay fuente válida, evitar errores
  
      const isHTML5Video = mediaEl.tagName === 'VIDEO';
      const isIframe = mediaEl.tagName === 'IFRAME';
  
      // Click en botón play
      if (playButton) {
        playButton.addEventListener('click', () => {
          if (isHTML5Video) {
            try {
              mediaEl.play();
              playButton.classList.add('hidden');
              mediaEl.controls = true;
            } catch (e) {
              // Ignorar
            }
          } else if (isIframe) {
            // Forzar autoplay agregando autoplay=1 al src del iframe
            try {
              const url = new URL(mediaEl.src);
              if (!url.searchParams.has('autoplay')) {
                url.searchParams.set('autoplay', '1');
                mediaEl.src = url.toString();
              } else {
                // Si ya tiene autoplay, simplemente oculta el botón
                mediaEl.src = url.toString();
              }
              playButton.classList.add('hidden');
            } catch (e) {
              // Fallback si URL() falla
              if (mediaEl.src.indexOf('autoplay=1') === -1) {
                const sep = mediaEl.src.indexOf('?') === -1 ? '?' : '&';
                mediaEl.src = mediaEl.src + sep + 'autoplay=1';
              }
              playButton.classList.add('hidden');
            }
          }
        });
      }
  
      if (isHTML5Video) {
        // Eventos solo para <video>
        mediaEl.addEventListener('pause', () => {
          if (playButton) playButton.classList.remove('hidden');
          mediaEl.controls = false;
        });
  
        mediaEl.addEventListener('ended', () => {
          if (playButton) playButton.classList.remove('hidden');
          mediaEl.controls = false;
        });
      }
    });
  });